import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SharedModule } from "@royalty/module";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { CoreErrorDialogComponent } from "./errordialog.component";
import { ErrorDialogService } from "./errordialog.service";
import { PosSharedService } from 'src/app/components/pos/shared/pos.shared.services';

@NgModule({
	imports: [MatButtonModule, MatDialogModule, SharedModule],
	providers: [ErrorDialogService, PosSharedService],
	declarations: [CoreErrorDialogComponent],
	entryComponents: [CoreErrorDialogComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorDialogModule {}
